<div [appStoryblok]="_editable()" class="h-100">
  <img [ngSrc]="getImageSrc()" fill>
</div>
